import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '@/store/auth';
import MainLayout from '@/components/layout/MainLayout.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { public: true },
  },
  {
    path: '/admin-login',
    name: 'AdminLogin',
    component: () => import('@/views/auth/AdminLogin.vue'),
    meta: { public: true },
  },
  {
    path: '/auth/wecom',
    name: 'WecomAuthCallback',
    component: () => import('@/views/auth/WecomCallback.vue'),
    meta: { public: true },
  },
  {
    path: '/',
    component: MainLayout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Index.vue'),
        meta: { title: '仪表盘', icon: 'Odometer' },
      },
      {
        path: 'enterprises',
        name: 'Enterprises',
        component: () => import('@/views/enterprise/Index.vue'),
        meta: { title: '企业', icon: 'OfficeBuilding', requireSuperAdmin: true },
      },
      {
        path: 'customers',
        name: 'Customers',
        component: () => import('@/views/customer/Index.vue'),
        meta: { title: '客户', icon: 'User' },
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/settings/Index.vue'),
        meta: { title: '系统设置', icon: 'Setting', requireSuperAdmin: true },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore();

  if (to.meta.public) {
    return next();
  }

  if (!authStore.isLoggedIn) {
    return next('/login');
  }

  if (!authStore.user) {
    await authStore.fetchUser();
    if (!authStore.user) {
      return next('/login');
    }
  }

  if (to.meta.requireSuperAdmin && !authStore.isSuperAdmin) {
    return next('/dashboard');
  }

  next();
});

export default router;
